// The brand: the Flat Five name and mark, in the topbar AND the nav drawer's
// head. One source for both render sites (a second hand-written copy is how
// the drawer once shipped the wrong name). The trial styles that carried other
// names retired in Oct 2026 (UI review phase 4). Non-component module
// (scoreShared.ts pattern) so fast-refresh lint stays clean.
const BRAND = { wordmark: 'Flat Five', sub: null as string | null };

export function useBrandText(): { wordmark: string; sub: string | null; homeLabel: string } {
  return { ...BRAND, homeLabel: `${BRAND.wordmark} home` };
}
